import Constants from "../../../common/src/Constants";
import HandleAsyncError from "../../../common/src/errors/ErrorHandlerDecorator";
import {HttpClient} from "../../../common/src/services/HttpClient";

export default class OverviewService extends HttpClient {

    public metricsService: any;

    constructor(metricsService: any) {
        super()
        this.metricsService = metricsService;
    }

    @HandleAsyncError()
    async onGetEntries (token: string) {
        let response = await super
            .get(`${Constants.API.URI.ENTRIES}`, token);
        return response.json();
    };

    @HandleAsyncError()
    async onGetExchangeRateExample (siteId: number) {
        let response = await super
            .get(`${Constants.API.URI.EXCHANGE_RATE}?siteId=${siteId}`)
        return response.json();
    };

    @HandleAsyncError()
    async onGetBPOverview(token: (string | null), siteDomain: string, lang: string) {
        const arrayLocale = lang.split('_');
        let response = await super
            .get(`${Constants.API.URI.REWARD_SHOP}?siteDomain=${siteDomain}&lang=${arrayLocale[0]}`, token);
        return response.json();
    };
}

